import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$2 } from './box.js';

const themeSectionCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;min-width:0;width:auto}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host([data-themed-fg]){color:var(--jw-theme-surface-text-default-color)}:host([data-themed-bg]){background-color:var(--jw-theme-surface-body-bg-color)}";
const WuiThemeSectionStyle0 = themeSectionCss;

const WuiThemeSection$1 = /*@__PURE__*/ proxyCustomElement(class WuiThemeSection extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.theme = 'light';
        this.themed = true;
        this.box = undefined;
    }
    render() {
        const themed = Array.isArray(this.themed) ? this.themed : ['fg', 'bg'];
        const boxProps = typeof this.box === 'boolean' ? {} : this.box;
        return (h(Host, { key: 'a3a3c9e7c522ecd59b4e87c498a1d8f82f649c9c', theme: this.theme ?? 'light', "data-themed-fg": themed.includes('fg'), "data-themed-bg": themed.includes('bg') }, this.box ? (h("wui-box", { style: { flex: '1' }, ...boxProps }, h("slot", null))) : (h("slot", null))));
    }
    static get style() { return WuiThemeSectionStyle0; }
}, [1, "wui-theme-section", {
        "theme": [513],
        "themed": [4],
        "box": [4]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-theme-section", "wui-box"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-theme-section":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiThemeSection$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiThemeSection = WuiThemeSection$1;
const defineCustomElement = defineCustomElement$1;

export { WuiThemeSection, defineCustomElement };

//# sourceMappingURL=wui-theme-section.js.map